import React from 'react';

const Settings = ({ settings, onUpdateSettings, themeClasses, isDarkMode }) => {
  const handleChange = (key, value) => {
    onUpdateSettings({
      ...settings,
      [key]: value
    });
  };

  return (
    <div className={`max-w-2xl mx-auto`}>
      <div className="mb-8">
        <h2 className={`text-xl font-bold uppercase tracking-widest mb-2 ${themeClasses.textMain}`}>Settings</h2>
        <p className={`${themeClasses.textMuted}`}>Manage your application preferences</p>
      </div>

      <div className="space-y-6">
        <div>
          <h3 className={`text-sm font-bold uppercase tracking-widest mb-4 ${themeClasses.textMain}`}>Collection & Variants</h3>
          <div className={`${themeClasses.card} p-6 rounded-lg border shadow-sm flex items-center justify-between`}>
            <div className="pr-4">
              <label className={`block font-medium mb-1 ${themeClasses.textMain}`}>Distinguish Variants by Year</label>
              <p className={`text-sm ${themeClasses.textMuted}`}>
                If enabled, coins from different years are treated as separate items. 
                If disabled, coins with the same Country and Denomination are grouped as variants regardless of year.
              </p>
            </div>
            
            <label className="relative inline-flex items-center cursor-pointer shrink-0">
              <input 
                type="checkbox" 
                checked={settings.variantIncludeYear} 
                onChange={(e) => handleChange('variantIncludeYear', e.target.checked)}
                className="sr-only peer"
              />
              <div className={`w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${isDarkMode ? 'peer-checked:bg-teal-500' : 'peer-checked:bg-teal-600'}`}></div>
            </label>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
